@if (carriersQueryResults$ | async; as result) {
<kendo-label text="Carrier">
    <kendo-multiselect [data]="result.data ?? []"
                       [disabled]="isDisabled || result.isLoading"
                       [loading]="result.isLoading"
                       [placeholder]="result.isLoading ? 'Loading' : ''"
                       [virtual]="virtual"
                       [value]="value"
                       textField="displayText"
                       valueField="scac"
                       (valueChange)="handleValueChange($event)"
                       (blur)="handleBlur()"
                       [valuePrimitive]="true">
    </kendo-multiselect>
</kendo-label>
}
